// Имя автора для шапки комментария/квоты. Если у пользователя задано имя —
// возвращаем его. Иначе — часть email до '@' (более читаемо чем полный email).
// Полный email рендерится отдельной строкой ниже — см. CommentsPanel и
// ItemCommentsPanel.
export function authorDisplayName(user: { name?: string | null; email: string }): string {
  const name = user.name?.trim()
  if (name) return name
  const local = user.email.split('@')[0]
  return local && local.length > 0 ? local : user.email
}
